module.exports = __webpack_public_path__ + "static/media/icons_Bilan Quadrant inférieur TMO.0d8d8d05.svg";